import React, {useEffect} from "react"
import Heading from "../../../../components/dashboard/heading-component/Heading";
import {useJournal} from "../../../../providers/JournalContext";
import JournalOtpVerification from "../../../auth/signin/otp-verification/JournalOtpVerification";
import {useLocation, useNavigate} from "react-router";

export default function JournalOtpScreen({close, getListing, setGetListing}) {
    const {userEmail} = useJournal()
    const { state } = useLocation();
    const navigate = useNavigate()
    const {verifyJournalOtp } = useJournal()

    useEffect(()=>{
        if (state === null) {
            navigate('/journals/validate-password');
        }
    })


    return(
        <div className={'align-content-center h-100'}>
            <div className={'validate-journals'}>
                <Heading heading={`Please enter the OTP you received to ${state?.email}`} back={false}/>
                <p>Verify OTP to proceed further.</p>
                <JournalOtpVerification redirect={'/journals/reset-password'} email={state?.email}/>
            </div>
        </div>
    )
}